module.exports = __webpack_public_path__ + "static/GreycliffCF-Bold-844e749073adf488ee6baf7bb6753756.otf";